import React from 'react'
import { withApollo } from 'react-apollo'
import PropTypes from 'prop-types'
import { 
         Tabs, 
         Typography, 
         Spin, Row,
          Col,
          Input,
          message,
          Table,
          Icon,
          Button,
          Popconfirm,
          Form,
          Select,
          DatePicker,
          Checkbox,
          Modal,
          Avatar
      } from 'antd'
import moment from 'moment'
import { Queries, Mutations } from '../../../../graphql'
import { alertMessage } from '../../../../utils/message'
const { Text, Title } = Typography
const { Option } = Select;
const { TextArea } = Input

class TableCCEmail extends React.PureComponent {
   formRefCheckBox = React.createRef()
   state = {
      preLoadSubmitModal:false,
      loading:false,
      dataTalbeCheckBox: [],
      dataTalbe: [],
      columns: [
         {
            title: 'ลำดับ',
            dataIndex: 'empCodeTo',
            width:90,
            align:'center',
            render: (item, record, index) => {
               return(
                  <>
                     <span>{ (this.state.pageData.offset+index) + 1}</span>
                     <Form.Item label={""} hidden>
                        { this.props.getFieldDecorator(`notiCC[${index}]["empCodeFrom"]`, {
                           initialValue: this.props.detailProfile.empCode,
                        })(
                           <Input />
                        )}
                     </Form.Item>
                     <Form.Item label={""} hidden>
                        { this.props.getFieldDecorator(`notiCC[${index}]["empCodeTo"]`, {
                           initialValue: item ? item : [],
                        })(
                           <Input/>
                        )}
                     </Form.Item>
                  </>
               )
            }
         },
         {
            title: ()=>{
               return <span>รหัสบุคลากร</span>
            },
            dataIndex: "empCodeTo",
            align: "left",
            render: (item, record, index) => {
               return (
                  <>
                  <Form.Item
                     // name={`notiCC[${index}]["empName"]`}
                     label={""}
                     initialValue={ item ? item : "" }
                     hidden
                     rules={[
                        {
                           required: true,
                           message: "กรุณาระบุ ชื่อ-นามสกุล"
                        },
                     ]}
                  >
                     <Input />
                  </Form.Item>
                  {item}
                  </>
               );
            },
         },
         {
            title: ()=>{
               return <span>ชื่อ-นามสกุล</span>
            },
            dataIndex: "fullnameTo",
            align: "center",
            render: (item, record, index) => {
               return(
                  <>
                     <div align={"left"}>
                        <Form.Item label={""} hidden>
                           { this.props.getFieldDecorator(`notiCC[${index}]["fullnameFrom"]`, {
                              initialValue: this.props.detailProfile.empName,
                           })(
                              <Input />
                           )}
                        </Form.Item>
                        <Form.Item label={""} hidden>
                           { this.props.getFieldDecorator(`notiCC[${index}]["fullnameTo"]`, {
                              initialValue: item ? item : [],
                           })(
                              <Input />
                           )}
                        </Form.Item>
                        {item}
                     </div>
                  </>
               )
            }
         },
         {
            title: 'สำนัก',
            dataIndex: 'organiztionNameTo',
            width:'200px',
            align:'center',
            // sorter: (a, b) => a.orgCode - b.orgCode,
            render: (item, record, index) => <div>
                                                <span>{ item } </span>
                                                <Form.Item label={""} hidden>
                                                   { this.props.getFieldDecorator(`notiCC[${index}]["organiztionNameFrom"]`, {
                                                      initialValue: this.props.detailProfile.organiztionName,
                                                   })(
                                                      <Input />
                                                   )}
                                                </Form.Item>
                                                <Form.Item label={""} hidden>
                                                   { this.props.getFieldDecorator(`notiCC[${index}]["organiztionNameTo"]`, {
                                                      initialValue: item ? item : [],
                                                   })(
                                                      <Input />
                                                   )}
                                                </Form.Item>
                                             </div>
         },
         {
            title: 'ฝ่าย / หน่วยงาน',
            dataIndex: 'divisionTo',
            width:300,
            align:'center',
            render: (item, record, index) => <div  style={{ textAlign:"left" }}>
                                                { item }
                                                <Form.Item label={""} hidden>
                                                   { this.props.getFieldDecorator(`notiCC[${index}]["divisionFrom"]`, {
                                                      initialValue: this.onChangeNameDivitions(this.props.detailProfile.division, this.props.detailProfile.department),
                                                   })(
                                                      <Input />
                                                   )}
                                                </Form.Item>
                                                <Form.Item label={""} hidden>
                                                   { this.props.getFieldDecorator(`notiCC[${index}]["divisionTo"]`, {
                                                      initialValue: item ? item : [],
                                                   })(
                                                      <Input />
                                                   )}
                                                </Form.Item>
                                             </div>
         },
         {
            title: 'จัดการ',
            dataIndex: '7',
            width:'20px',
            vertical:'top',
            align:'center',
            render: (item, record, index) => {
               return this.showDetailBtnInput(record, index)
            }
         },
      ],
      pageData: {
         offset: 0,
         limit: 10
      },
      pagination: {
         total: 10,
      },
      arrayDataSearchEmailCC: [],
      dataTalbeSearchCC: [],
      columnsDataTalbeSearchCC: [
         {
            title:  () =>{ 
               return   <Checkbox 
                           checked={ this.state.checkBoxTitle }
                           onChange={(e) => this.onChangeSlectAll(e.target.checked)}
                        >
               </Checkbox>
            },
            dataIndex: 'empCode',
            width:90,
            align:'center',
            // render: (item, record, index) => <span>{ (this.state.pageData.offset+index) + 1}</span>
            render: (item, record, index) => {
               return (
                  <>
                     <Form.Item name={record.orgUnitCode} className="mb-0">
                        <Checkbox 
                           checked={record.statusCheckBox ? record.statusCheckBox : false} 
                           onChange={
                                 (e) => this.onChangeSlectTable(e.target.checked, record)
                           }
                           // disabled={ this.checkDisabledCheckBox(values) }
                           style={{ marginTop:"-5px" }}
                        >
                        </Checkbox>
                     </Form.Item>
                  </>
               )
            }
         },
         {
            title: ()=>{
               return <span>รหัสบุคลากร</span>
            },
            dataIndex: "empCode",
            align: "left",
            render: (item, record, index) => {
               return (
                  <>
                  <Form.Item
                     // name={`notiCC[${index}]["empName"]`}
                     label={""}
                     initialValue={ item ? item : "" }
                     rules={[
                        {
                           required: true,
                           message: "กรุณาระบุ ชื่อ-นามสกุล"
                        },
                     ]}
                  >
                     <Input hidden/>
                     {item}
                  </Form.Item>
                  </>
               );
            },
         },
         {
            title: ()=>{
               return <span>ชื่อ-นามสกุล</span>
            },
            dataIndex: "empName",
            align: "center",
            render: (item, record, index) => {
               return (
                  <>
                     <div align={"left"}>
                        <Form.Item
                           name={`notiCC[${index}]["empName"]`}
                           label={""}
                           initialValue={ item ? item : "" }
                           rules={[
                              {
                                 required: true,
                                 message: "กรุณาระบุ ชื่อ-นามสกุล"
                              },
                           ]}
                        >
                           <Input hidden/>
                           {item}
                        </Form.Item>
                     </div>
                  </>
               );
            },
         },
         {
            title: 'สำนัก',
            dataIndex: 'organiztionName',
            width:'200px',
            align:'center',
            // sorter: (a, b) => a.orgCode - b.orgCode,
            render: (item, record, index) => <span>{ item } </span>
         },
         {
            title: 'ฝ่าย / หน่วยงาน',
            dataIndex: 'department',
            width:300,
            align:'center',
            render: (item, record, index) => <div  style={{ textAlign:"left" }}>
                                                { this.onChangeNameDivitions(record.division, record.department) ? this.onChangeNameDivitions(record.division, record.department) : '-' }
                                             </div>
         },
      ],
      dataTalbeCheckBox: [],
   }

   onChangeNameDivitionsSend = () =>{

   }

   onChangeNameDivitions = (division, department) =>{
      if(division && department){
         return  division+' / '+department
      }else if(division){
         return  division
      }else if(department){
         return  department
      }else{
         return null 
      }
   }

   showDetailBtnInput = (record, arrayId) => {
      const { isViewOnly } = this.props
       const { dataTalbe } = this.state;
       // disabled={ this.props.isViewOnly }
       return (
            <>
               <Avatar 
                  shape="square"  
                  icon={<Icon type="delete" />} 
                  className={`mr-1 mb-1`}
                  onClick={ () => !isViewOnly ? this.destroyArrayDataUploads(arrayId) : '' }
                  style={{ cursor: !isViewOnly ? 'pointer' : 'no-drop', background: !isViewOnly ? 'red' : '#9d9d9d' }}
               />
            </>
       );
    };
 
    destroyArrayDataUploads = async (arrayId) => {
       const { formRef } = this.props;
       const { dataTalbe } = this.state;
       var arrayDataSource = [...this.state.dataTalbe];
       arrayDataSource.splice(arrayId, 1);
   
      // console.log('studyStrategy', studyStrategy)
       await this.setState(
         {
           dataTalbe: arrayDataSource,
           // dataTalbeLength: lengthData
         },
         async () => {
             arrayDataSource.map(async (valuesTable, keysTable) => {
    
               // await Object.assign(notiCC[keysTable], 
               //    { 
               //       empCode: valuesTable.empCode,
               //       empName: valuesTable.empName,
               //    }
               // )
    
               //  await formRef.current.setFieldsValue({ notiCC })
             });
          }
       );
    };

   showDataInputUploads = async () => {
      await this.setState({
         ModalCreateCCFormTitle:"เพิ่มผู้เกี่ยวข้อง",
         ModalCreateCCFormSubTitle:null,
         ModalCreateCCFormShowModal:true,
         ModalCreateCCFormBtnOk:"เพิ่ม",
         ModalCreateCCFormBtnCancel:"ปิด",
         ModalCreateCCFormValue:null,
         dataTalbeCheckBox: [],
         dataTalbeSearchCC: []
     })
   };

   formRefSearchEmailCC = async (e) =>{
      const { client, location, match } = this.props
      const { form } = this.props
      e.preventDefault()
     
      // console.log('this.formRefCheckBox', this.props)
      // console.log('this.props', this.props)
      form.validateFields(async (err, values) => {
         if (!err) {
            // this.props.resetFields();
            // await this.props.setFieldsValue({
            //    empCode: values.empCode
            // })
            await this.setState({
               dataTalbeCheckBox: [],
               loadingModal:true
            })
            const { data, errors } = await client.query({
                  query: Queries.fetchDetailProfileListCC,
                  variables:{
                     search:values.search,
                  }
            })
      
            console.log('values.search', values.search)
            console.log('data.fetchDetailProfileListCC', data.fetchDetailProfileListCC)
            if(data.fetchDetailProfileListCC){
               await this.setState({
                  dataTalbeSearchCC: data.fetchDetailProfileListCC,
                  loadingModal: false
               })
            }else{
                  await this.setState({
                     loadingModal: false,
                     dataTalbeSearchCC:[]
                  })
            }
         }else{
          
         }
      })
   }

   
   onChangeSlectAll = async (value) =>{
		const { dataTalbeSearchCC } = this.state
		let arrayNewsDataTable = []
		const rowsDataSelectTable = []
		const rows = null
		if(value){
			await dataTalbeSearchCC.map((values, keys)=>{
            values.statusCheckBox = value
            arrayNewsDataTable[keys] = values
            rowsDataSelectTable.push({
                     empCode: values.empCode,
                     empName: values.empName,
                     division: values.division, 
                     department: values.department,
                     organiztionName: values.organiztionName
                  })
			})
		}else{
			await dataTalbeSearchCC.map((values, keys)=>{
				values.statusCheckBox = value
				arrayNewsDataTable[keys] = values
			})
		}

      console.log('arrayNewsDataTable', dataTalbeSearchCC)

		await this.setState({
			dataTalbeSearchCC: arrayNewsDataTable,
			dataTalbeCheckBox:rowsDataSelectTable,
			checkBoxTitle:value
		})
		
	}

   onChangeSlectTable = async (checked, valueData) =>{
      let dataSourceitems = [...this.state.dataTalbeCheckBox];
      let keysdataSelectTable = null
      let newsKeyArrayId = null
      let newsKeyArraySearch = null

      let dataSourceitemsTable = [...this.state.dataTalbeSearchCC];

      // console.log('dataSourceitemsTable', dataSourceitemsTable)
      // console.log('valueData.empCode', valueData.empCode)
        dataSourceitemsTable.map(async(filtereditem, keys) =>{
            if(filtereditem.empCode == valueData.empCode){
                newsKeyArraySearch = keys
            }
        })

        let item = {...dataSourceitemsTable[newsKeyArraySearch]};
        item.statusCheckBox = checked

        dataSourceitemsTable[newsKeyArraySearch] = item;

        await this.setState({
            dataTalbeSearchCC:dataSourceitemsTable
        },() => {
            // this.cllBackSetValueContactNumber()
        })

      dataSourceitems.map(async(filtereditem, keys) =>{
         if(filtereditem.empCode == valueData.empCode){
            newsKeyArrayId = keys
         }
      })

      if(newsKeyArrayId || newsKeyArrayId == 0){
         if(checked){
            const rows = {
               empCode: valueData.empCode,
               empName: valueData.empName,
               division: valueData.division, 
               department: valueData.department,
               organiztionName: valueData.organiztionName
           }
           await this.setState(prevState => ({
               dataTalbeCheckBox: [...prevState.dataTalbeCheckBox, rows],
           }))
         }else{
            dataSourceitems.splice(newsKeyArrayId, 1);
            await this.setState({
               dataTalbeCheckBox:dataSourceitems,
            })
         }
      }else{
         const rows = {
            empCode: valueData.empCode,
            empName: valueData.empName,
            division: valueData.division, 
            department: valueData.department,
            organiztionName: valueData.organiztionName
        }
        await this.setState(prevState => ({
            dataTalbeCheckBox: [...prevState.dataTalbeCheckBox, rows],
        }))
      }
      //   let item = {...dataSourceitems[newsKeyArrayId]};
      //   item.statusCheckBox = checked
   }

   onSubmitModalCreateCC = async () =>{
      const { dataTalbe, dataTalbeCheckBox } = this.state
      let row = [];
      let checkValue = []
      await dataTalbeCheckBox.map((valuesCheckBox, keysCheckbox)=>{
         dataTalbe.map((values, keys)=>{
            if(valuesCheckBox.empCode == values.empCodeTo){
               checkValue.push(values.empCode)
            }
         })

         valuesCheckBox.empCodeTo = valuesCheckBox.empCode
         valuesCheckBox.fullnameTo = valuesCheckBox.empName
         valuesCheckBox.organiztionNameTo = valuesCheckBox.organiztionName
         valuesCheckBox.divisionTo = this.onChangeNameDivitions(valuesCheckBox.division, valuesCheckBox.department)
         row.push(valuesCheckBox)
      })

      console.log('dataTalbeCheckBox', dataTalbeCheckBox)
      
      if(dataTalbeCheckBox.length > 0){
         if(checkValue.length == 0){
            await this.setState(prevState => ({
               dataTalbe: [...prevState.dataTalbe, ...row].sort((p1, p2) => (parseFloat(p1.empCodeTo) > parseFloat(p2.empCodeTo)) ? 1 : (parseFloat(p1.empCodeTo) < parseFloat(p2.empCodeTo)) ? -1 : 0),
               ModalCreateCCFormTitle:null,
               ModalCreateCCFormSubTitle:null,
               ModalCreateCCFormShowModal:false,
               ModalCreateCCFormBtnOk:null,
               ModalCreateCCFormBtnCancel:null,
               ModalCreateCCFormValue:null,
               dataTalbeCheckBox:[],
               checkBoxTitle: false
            }))
         }else{
            alertMessage("error","ไม่สามารถทำการเพิ่มผู้เกี่ยวข้องซ้ำได้")
         }
      }else{
         alertMessage("error","กรุณาเลือกอย่างน้อย 1 รายการ")
      }
     
      
   }

   hideModalCreateCC = async () =>{
      await this.setState({
          ModalCreateCCFormTitle:null,
          ModalCreateCCFormSubTitle:null,
          ModalCreateCCFormShowModal:false,
          ModalCreateCCFormBtnOk:null,
          ModalCreateCCFormBtnCancel:null,
          ModalCreateCCFormValue:null,
          dataTalbeCheckBox:[],
          checkBoxTitle: false
      })
   }
   
	async componentDidMount() {
      const { rawDataDetail = null } = this.props
      console.log('rawDataDetail', rawDataDetail)
        if(rawDataDetail){
            await this.setState({
               dataTalbe:rawDataDetail.sort((p1, p2) => (parseFloat(p1.empCodeTo) > parseFloat(p2.empCodeTo)) ? 1 : (parseFloat(p1.empCodeTo) < parseFloat(p2.empCodeTo)) ? -1 : 0),
            })
        }
	}

	render() {
      const { 
			columns,
         dataTalbe,
         preLoadOnsubmit,
         ModalCreateCCFormTitle,
         ModalCreateCCFormSubTitle,
         ModalCreateCCFormShowModal,
         ModalCreateCCFormBtnOk,
         ModalCreateCCFormBtnCancel,
         ModalCreateCCFormValue,
         arrayDataSearchEmailCC,
         dataTalbeCheckBox,
         columnsDataTalbeSearchCC,
         dataTalbeSearchCC,
         loadingModal,
		} = this.state

      const { isViewOnly = false } = this.props

      console.log('getFieldDecorator', dataTalbe)
		return (
			<>
            <Modal
               destroyOnClose={true}
               maskClosable={false}
               visible={ModalCreateCCFormShowModal}
               // visible={true}
               title={ModalCreateCCFormTitle}
                  // onOk={ () =>{
                  //     this.onSubmit()
                  // }}
               onCancel={
                  () =>{
                     this.hideModalCreateCC()
                  }
               }
               footer={null}
               width={1000}
               okText={ ModalCreateCCFormBtnOk }
               cancelText={ ModalCreateCCFormBtnCancel }
            >
               <Form 
                  onSubmit={this.formRefSearchEmailCC} 
               >
                  <Row gutter={16} type="flex" justify="left" align="top">
                     <Col xs={24} md={12}>
                        <Row type="flex" justify="left" align="top" >
                           <Col xs={24} md={22}>
                              <Form.Item label={"ค้นหา"}>
                                 { this.props.form.getFieldDecorator("search", {
                                    initialValue: '',
                                    rules:  [{ 
                                       required:false, 
                                    }],
                                 })(
                                    <Input 
                                       className='block-news'
                                       style={{ borderRadius:"0" }}
                                    />
                                 )}
                              </Form.Item>
                           </Col>
                           <Col xs={24} md={2}>
                              <div style={{ height: "44px" }}></div>
                              <div
                                 className="box-select-create"
                              >
                                 <Button
                                    style={{ width: "100%", height:"33px !important", borderRadius:"0" }}
                                    type="primary "
                                    // htmlType="submit"
                                    className="px-0"
                                    onClick={this.formRefSearchEmailCC}
                                 >
                                    <Icon type="search" />
                                 </Button>
                              </div>
                           </Col>
                           
                        </Row>
                     </Col>
                  </Row>
               </Form>
               <Row>
                  <Col md={24} align="center">
                     <Table
                        columns={columnsDataTalbeSearchCC}
                        dataSource={dataTalbeSearchCC}
                        pagination={false}
                        loading={loadingModal}
                        className="mb-3"
                        bordered
                        rowCount={dataTalbe.length}
                        locale={{ emptyText: 'ไม่พบข้อมูลรายการ' }} 
                     />
                  </Col>

                  <Col xs={24} md={24} align={"center"} className="mt-4">
								{/* <Popconfirm placement="topLeft" title={"คุณต้องการที่จะไม่อนุมัติเอกสารการขอลาที่คุณเลือก"} onConfirm={this.submitReject} okText="ยืนยัน" cancelText="ยกเลิก"> */}
                        <Button 
                           type="primary" 
                           className="mx-2 btn-white-red" 
                           // htmlType="submit" 
                           onClick={ this.hideModalCreateCC }
                        >
                           ยกเลิก
                        </Button>
								<Button 
                           type="primary" 
                           className="ml-2 color-white" 
                           // htmlType="submit" 
                           onClick={this.onSubmitModalCreateCC}
                        >
									เพิ่ม
								</Button>
							</Col>
               </Row>
               {/* {
                  arrayDataSearchEmailCC.map((values, keys)=>{
                     return <Row gutter={16} type="flex" justify="left" align="top">
                              <Col md={2} align="center">
                                 <Form.Item label={""} className="mb-0">
                                    { getFieldDecorator(values.nameForm, {
                                       initialValue: '',
                                       valuePropName: 'checked', // add this line, man...
                                       rules:  [{ 
                                          required:false, 
                                       }],
                                    })(
                                       <Checkbox 
                                          onChange={
                                             (e) => this.onChangeSlectTable(e.target.checked, values)
                                          }
                                          // disabled={ this.checkDisabledCheckBox(values) }
                                          // ref={this.formRefCheckBox} 
                                          style={{ marginTop:"-5px" }}
                                       >
                                       </Checkbox>
                                    )}
                                 </Form.Item>
                              </Col>
                              <Col md={22}>
                                 <p className="mb-0 pt-2">{ values.empName }</p>
                              </Col>
                              <Col md={24}>
                                 <hr></hr>
                              </Col>
                           </Row>
                  })
               } */}
				</Modal>
               <Row gutter={16} type="flex" justify="left" align="top" className="">
                  <Col xs={24} md={24} className="pt-2">
                        <strong className="color-red">
                           เพิ่มผู้เกี่ยวข้อง
                        </strong>
                  </Col>
                  <Col xs={24} md={24} className="pt-2" align="right">
                        <Table
                           columns={columns}
                           dataSource={dataTalbe}
                           pagination={false}
                           className="mb-3"
                           bordered
                           rowCount={dataTalbe.length}
                           locale={{ emptyText: 'ไม่พบข้อมูลรายการ' }} 
                        />
                        {
                           !isViewOnly &&
                           <Button 
                              style={{ display:"inline-block" }}
                              className="mt-1 mr-2 y btn-color-default btn-custom btn-clear color-white"
                              type="primary" 
                              disabled={ preLoadOnsubmit }
                              onClick={ () => this.showDataInputUploads() }
                           >
                              เพิ่ม +
                           </Button>
                        }
                        
                  </Col>
               </Row>
            </>
		)
	}
}

TableCCEmail.defaultProps = {
	autoFocus: false
}

TableCCEmail.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedDelegateFormModal = Form.create()(TableCCEmail)

export default withApollo(WrappedDelegateFormModal)